<template>
	<div class="main-bg">
		<div class="main">
			<div class="content">
				<div class="left">
					<img src="../img/ic14.png" />
					<div class="info font-4">
						<p v-html="'作&emsp;词：单士勇&emsp;兰&emsp;红'"></p>
						<p v-html="'作&emsp;曲：韩&emsp;红'"></p>
						<p v-html="'演&emsp;唱：韩&emsp;红'"></p>
					</div>
				</div>
				<div class="right">
					<div class="lrc font-4">
						<div class="lrc-p">
							<p v-for="item , key in lrc" :key="key" :class="lrc_index == key ? 'red' : ''">{{item.content}}</p>
						</div>
					</div>
					<div class="audio">
						<img src="../img/ic17.png" class="img-1" v-show="isPlay" @click="pause">
						<img src="../img/ic38.png" class="img-1" v-show="!isPlay" @click="play">
						<img src="../img/ic18.png" class="img-2" @click="reset">
						<div class="progress">
							<el-slider @mousedown.native="isMove = true" @mouseup.native="isMove = false" @change="changeTime" v-model="now_time" :max="audio_time" :format-tooltip="format"></el-slider>
						</div>
						<font>{{format(now_time)}} / {{format(audio_time)}}</font>
						<img src="../img/ic22.png" class="img-3" v-show="isMute" @click="isMute = !isMute">
						<img src="../img/ic21.png" class="img-3" v-show="!isMute" @click="isMute = !isMute">
					</div>
				</div>
			</div>
			<jm-nav></jm-nav>
		</div>
		<img src="../img/ic10.png" class="body-bg" />
		<audio preload src="../media/凤凰花季.mp3"></audio>
	</div>
</template>
<script>
import jmNav from '../components/jm_nav.vue'
import $ from "jquery";
export default {
	data() {
		return {
			audio:'',
			isMove:false,
			isPlay:false,
			isMute:false,
			audio_time:0,
			now_time:0,
			lrc_index:-1,
			lrc:[{
				time: 14.7,
				content:'那一年'
			},{
				time:15.89,
				content:'风儿吹过七月的海面'
			},{
				time:20.75,
				content:'仿佛就那么一瞬间'
			},{
				time:24.34,
				content:'凤凰花开满天'
			},{
				time:28.55,
				content:'那一年'
			},{
				time:30.16,
				content:'我听到五老峰的呼唤'
			},{
				time:35.21,
				content:'仿佛就那么一瞬间'
			},{
				time:38.89,
				content:'凤凰花开满天'
			},{
				time:42.45,
				content:'那一年'
			},{
				time:44.68,
				content:'骊歌悠扬 蝉声渐远'
			},{
				time:49.2,
				content:'仿佛就在那么一瞬间'
			},{
				time:55.5,
				content:'挥别了芙蓉湖我泪流满面'
			},{
				time:62.87,
				content:'远处的凤凰花已含泪无言'
			},{
				time:83.86,
				content:'那一年'
			},{
				time:85.36,
				content:'骊歌悠扬 蝉声渐远'
			},{
				time:90.55,
				content:'仿佛就那么一瞬间'
			},{
				time:94,
				content:'已开始了想念'
			},{
				time:97.87,
				content:'挥别时你我相对泪流满面'
			},{
				time:104.7,
				content:'远处的凤凰花已含泪无言'
			},{
				time:113.27,
				content:'潮落潮涨 几度风霜'
			},{
				time:119.9,
				content:'青春不老 岁岁年年'
			},{
				time:126.62,
				content:'潮落潮涨 几度风霜'
			},{
				time:133.75,
				content:'青春不老 岁岁年年'
			},{
				time:168.69,
				content:'潮落潮涨 几度风霜'
			},{
				time:175.21,
				content:'青春不老 岁岁年年'
			},{
				time:181.99,
				content:'潮落潮涨 几度风霜'
			},{
				time:189.06,
				content:'青春不老 岁岁年年'
			},{
				time:196.48,
				content:'潮落潮涨 几度风霜'
			},{
				time:203.26,
				content:'青春不老 岁岁年年'
			},{
				time:210.16,
				content:'潮落潮涨 几度风霜'
			},{
				time:216.68,
				content:'青春不老 岁岁年年'
			},{
				time:224.48,
				content:'我走遍海角天边'
			},{
				time:227.19,
				content:'我踏过晨昏悲欢'
			},{
				time:231.37,
				content:'我心中为你吟唱'
			},{
				time:234.53,
				content:'那首老歌'
			},{
				time:238.01,
				content:'我走遍海角天边'
			},{
				time:241.51,
				content:'我踏过晨昏悲欢'
			},{
				time:244.81,
				content:'凤凰花看着我笑'
			},{
				time:248.04,
				content:'红霞漫天'
			},{
				time:251.8,
				content:'红霞漫天'
			}]
		}
	},
	mounted() {
		this.audio = document.getElementsByTagName("audio")[0];
		this.audio.oncanplay = () => {  
			if(!this.audio_time){
				this.audio_time = this.audio.duration
				this.play()
			}
		}
		this.audio.addEventListener("timeupdate",() => {
			if(!this.isMove)
				this.now_time = this.audio.currentTime
		})
	},
	methods: {
		play(){
			this.audio.play()
			this.isPlay = true
		},
		pause(){
			this.audio.pause()
			this.isPlay = false
		},
		reset(){
			this.audio.currentTime = 0
			this.pause()
		},
		changeTime(val){
			this.audio.currentTime = parseInt(val)
		},
		format(time){
			let i = parseInt(time / 60)
			let s = parseInt(time % 60)
			if(i < 10)
				i = "0" + i;
			if(s < 10)
				s = "0" + s;
			return i + ':' + s
		}
	},
	watch:{
		isMute(val){
			this.audio.muted = val
		},
		now_time(val){
			for(let i = this.lrc.length - 1 ; i >= 0 ; i--){
				var item = this.lrc[i]
				if(val > item.time){
					this.lrc_index = i
					break;
				}
			}
		},
		lrc_index(val){
			$(".lrc-p").stop(true,true).animate({top:'-' + (val * 1.7) + 'rem'});
		},
	},
	components:{
		jmNav
	}
}
</script>
<style scoped>
.main{
	background: rgba(255,255,255,.3);
	width: 70rem;
	margin: 0 auto;
	border-radius: .5rem;
	padding-bottom: 2rem;
	z-index: 2;
	position: fixed;
	left: 50%;
	margin-left: -35rem;
	top: 50%;
	transform: translateY(-50%);
}
.main .content{
	padding-top: 2rem;
	display: flex;
	background: url(../img/ic15.png) no-repeat right top;
	height: 31rem;
}
.main .left{
	margin-left: 4rem;
	align-items: center;
	display: flex;
	flex-direction: column;
}
.main .left img{
	display: flex;
	width: 7.5rem;
}
.main .info{
	margin-top: 1.5rem;
}
.main .info p{
	font-size: .9rem;
	color:#000;
	margin-top: .5rem;
}
.body-bg{
	position: fixed;
	width: 100%;
	bottom: 0;
	left: 0;
}
.right{
	width: 40rem;
}
.lrc-p{
	position: relative;
}
.lrc{
	height: 27.1rem;
	overflow: hidden;
}
.lrc p{
	font-size: 1.1rem;
	color: #92443c;
	height: 1.7rem;
	display: flex;
	align-items: center;
	justify-content: center;
}
.audio{
	display: flex;
	align-items: center;
	justify-content: center;
}
.audio font{
	color: #d7412a;
	font-weight: bold;
	margin-left: .5rem;
}
.img-1{
	display: flex;
	width: 1rem;
	height: 1rem;
	margin-right: .5rem;
	cursor: pointer;
}
.img-2{
	display: flex;
	width: 1rem;
	height: 1rem;
	margin-right: 1rem;
	cursor: pointer;
}
.img-3{
	display: flex;
	width: 1.35rem;
	height: 1rem;
	margin-left:.5rem;
	cursor: pointer;
}
.progress{
	width: 15rem;
}
.lrc-p .red{
	color: #d7412a;
	font-weight: bold;
}
</style>